import { APP_ROUTES } from './AppRoutes';

export * from './currency';
export * from './AppRoutes';

export const PFX_SUPPORT_URL =
  'https://pfxlabs.atlassian.net/servicedesk/customer/portal/14/group/38/create/156';

export const DEFAULT_STALE_TIME = 1000 * 60 * 60;

export const GROWTH_OS_AUTH_PARAM = 'growthOS';

export const HSA_ONBOARD_STEPS = [
  { label: 'Account Details', path: APP_ROUTES.ONBOARD_ACCT_DETAILS },
  { label: 'Properties', path: APP_ROUTES.ONBOARD_HSA_PROPERTIES },
  { label: 'Brand Signifiers', path: APP_ROUTES.ONBOARD_HSA_SIGNIFIERS },
  { label: 'Whitelisted Domains', path: APP_ROUTES.ONBOARD_HSA_WHITELIST },
  { label: 'Auction Insights File', path: APP_ROUTES.ONBOARD_HSA_FILE_UPLOAD },
];

export const RECALCULATE_HSA_STEPS = [
  { label: 'Properties', path: APP_ROUTES.ONBOARD_HSA_PROPERTIES },
  { label: 'Brand Signifiers', path: APP_ROUTES.ONBOARD_HSA_SIGNIFIERS },
  { label: 'Whitelisted Domains', path: APP_ROUTES.ONBOARD_HSA_WHITELIST },
  { label: 'Auction Insights File', path: APP_ROUTES.ONBOARD_HSA_FILE_UPLOAD },
];
